import { Box, Divider, Typography } from "@mui/material";
import Big from "big.js";
import { displayPercentage, displayPrice } from "../../common/util/DisplayUtil";

export default function SalesLogCostSummary({
  salesLog,
  calculateTotal = false,
}) {
  let { subtotal, transactionFeeAmount, total, salesTaxAmount, salesTaxPct } =
    salesLog;
  const taxLabel =
    salesTaxPct !== undefined && salesTaxPct !== null
      ? `Tax (${Big(salesTaxPct).times(100)}%):`
      : "Tax:";

  return (
    <Box sx={{ width: "100%" }}>
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Typography data-testid="quantity-label">Quantity:</Typography>
        <Typography data-testid="quantity-value">
          {salesLog.items?.reduce((acc, item) => acc + item.quantity, 0)}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Typography data-testid="subtotal-label">Subtotal:</Typography>
        <Typography data-testid="subtotal-value">
          {displayPrice(subtotal)}
        </Typography>
      </Box>
      {salesTaxAmount > 0 && (
        <Box display="flex" justifyContent="space-between" mt={1}>
          <Typography data-testid="tax-label">{taxLabel}</Typography>
          <Typography data-testid="tax-value">
            {displayPrice(salesTaxAmount)}
          </Typography>
        </Box>
      )}
      {transactionFeeAmount > 0 && (
        <Box display="flex" justifyContent="space-between" mt={1}>
          <Typography data-testid="transaction-fee-label">
            Transaction Fee:
          </Typography>
          <Typography data-testid="transaction-fee-value">
            {displayPrice(transactionFeeAmount)}
          </Typography>
        </Box>
      )}
      <Divider />
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Typography variant="h6" data-testid="total-label">
          Total:
        </Typography>
        <Typography variant="h6" fontWeight="bold" data-testid="total-value">
          {displayPrice(total)}
        </Typography>
      </Box>
    </Box>
  );
}
